import { render, staticRenderFns } from "./TradeDetails.vue?vue&type=template&id=1d1c6cbc&scoped=true&"
import script from "./TradeDetails.vue?vue&type=script&lang=js&"
export * from "./TradeDetails.vue?vue&type=script&lang=js&"
import style0 from "./TradeDetails.vue?vue&type=style&index=0&id=1d1c6cbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1c6cbc",
  null
  
)

export default component.exports